import React, { useContext } from 'react';

export interface IntercomContextType {}

export const IntercomContext = React.createContext<IntercomContextType>(undefined!);

export const useIntercomContext = () => useContext(IntercomContext);
